import React, { Component } from 'react';
import applicationRouter from '~/hoc/applicationRouter'
import { inject, observer } from 'mobx-react';

import '../../../../styles/css/styles.css';
import plus_box from '../../../../assets/img/plus-box.svg'

// Components
import { Input } from '../../../../elements/Input';

import withRemoveDialog from '~/hoc/withRemoveDialog';
import withLocalization from '~/hoc/withLocalization';
import ChecklistTemplateTreeView from './ChecklistTemplateTreeView';
import { ProjectsWidget } from '../../../../components/GenericForm/Widgets/ProjectsWidget';

class ChecklistTemplateAddEdit extends Component {
    constructor(props) {
        super(props);
        this.timeout = 0;
    }

    loadData = async () => {
        const { checklistStore, id, add } = this.props;
        if (id && id > 0) {
            checklistStore.loadChecklistTemplate(id, add).then((elementsResult) => {
            });
        } else {
            checklistStore.returnDefaultNewChecklistTemplate();
        }
        this.props.checklistStore.checklistTemplateDoSearch("");
    }

    componentDidMount() {
        this.loadData();
    }

    doSearch(evt) {
        this.props.checklistStore.checklistTemplateDoSearch(evt.target.value);
    }

    onassignedchecklist = async (item) => {
        await this.props.checklistStore.onassignedchecklist(item)
    };

    // handleUpdateElement = async (item) => {
    //     let currentassignedarray = this.state.assignedelements;
    //     this.state.assignedelements.map((item, index) => {
    //         item["newkey"] = "aaaaaaaaaaaaaaaa";
    //     });
    // }

    unassignedelement = async (item) => {
        await this.props.checklistStore.unassignedelement(item)
    };

    handleChange = (name, value) => {
        this.props.checklistStore.checklistTemplateHandleChange(name, value)
    };

    render() {
        const { t } = this.props;
        const { currentChecklistTemplate } = this.props.checklistStore;

        // let reportedUsername = `${currentUser.first_name} ${currentUser.last_name}`;
        return (
            <div className="page" style={{ padding: 0, margin: 0 }}>
                <div className="page__content">
                    <form className="custom-form">
                        <div className="custom-form__row w-50">
                            <div className="custom-form__col">
                                <ProjectsWidget
                                    label={`${t('Project')} *`}
                                    value={currentChecklistTemplate.project_id}
                                    name="project_id"
                                    allowAll={false}
                                    onChange={value => {
                                        this.handleChange('project_id', value);
                                    }}
                                    error={!currentChecklistTemplate.project_id}
                                />
                            </div>
                        </div>
                        <div className="custom-form__row w-50">
                            <Input
                                className="custom-form__col"
                                label={`${t('Checklist Name')} *`}
                                placeholder={t('Checklist Name')}
                                type="text"
                                name="checklistname"
                                value={currentChecklistTemplate.checklistname}
                                onChange={evt => {
                                    this.handleChange('checklistname', evt.target.value);
                                }}
                                error={!currentChecklistTemplate.checklistname}
                            />
                        </div>
                        <div className='w-50'>
                            <div className="form-group has-feedback">
                                <Input
                                    className="custom-form__col"
                                    label={`${t('Add Elements')} *`}
                                    placeholder={t('Search Elements here')}
                                    type="text"
                                    ref="searchInput"
                                    name="Element_search"
                                    value={currentChecklistTemplate.searchText}
                                    onChange={(evt) => this.doSearch(evt)}
                                />
                            </div>
                        </div>
                        <div className="custom-form__row ml-10"> <label>{t('Click on element to add to your list.')}</label></div>
                        <div className='row m-0'>
                            {currentChecklistTemplate.elementlist.length > 0
                                ? currentChecklistTemplate.elementlist.map((item, index) => (
                                    <div className="col-sm-12 col-md-6 col-lg-3 p-2">
                                        <div className="d-flex"
                                            style={{ cursor: 'cell' }}
                                            onClick={() => this.onassignedchecklist(item)}>
                                            <img src={plus_box} alt='plus'/> 
                                            <div className="ml-10 elementformcontrolc d-flex align-items-center">
                                                   {item.name}
                                            </div>
                                        </div>
                                    </div>
                                ))
                                : null}
                        </div>
                        <div className='ml-10'>
                            <label>{t('Assigned element list')}</label>
                            <div>
                                {currentChecklistTemplate.assignedelements.length > 0 ? (
                                    currentChecklistTemplate.assignedelements.map((item, index) => (
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12  elementgridc">
                                            <div className="checkelistementcrow">
                                                <div className='d-flex align-items-center'>
                                                    <div
                                                        className=" elementtreerowlabel d-flex align-items-center">
                                                        Category: {item.name}
                                                    </div>
                                                    <i
                                                        className="fa fa-close elementiconc"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => this.unassignedelement(item)}
                                                    ></i>
                                                </div>
                                                <div className='mt-2'>
                                                    <ChecklistTemplateTreeView
                                                        data={item}
                                                        headingcolor="#F6F6F6"
                                                        key={item.id}
                                                        paddingLeft={0}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                        <h4>{t('No elements assigned...')}</h4>
                                    )}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default inject('checklistStore', 'authStore', 'userStore', 'commonStore')(
    applicationRouter(withLocalization(withRemoveDialog(observer(ChecklistTemplateAddEdit))))
);
